<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<figure class="figure">
<p class="fig"><img alt="" height="69" src="images/wsu-tvmlogo.jpg" width="75"/></p>
</figure>
<p class="sert"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span>TV Milestones Series</p>
<p class="serahaft">Series Editor</p>
<p class="sered">Barry Keith Grant, Brock University</p>
<p class="seraft">TV Milestones is part of the Contemporary Approaches to Film and Media Series</p>
<p class="serp">A complete listing of the books in this series can be found online at <a class="url" href="http://www.wsupress.wayne.edu" target="_blank">wsupress.wayne.edu</a>.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmouterlimits-0003.vue?f208709a